export const clampInt = (value, { min, max, fallback }) => {
  const numericValue = Number.parseInt(String(value), 10);

  if (Number.isNaN(numericValue)) return fallback;
  if (typeof min === 'number' && numericValue < min) return min;
  if (typeof max === 'number' && numericValue > max) return max;

  return numericValue;
};

export const createToggleSectionHandler = (setState) => (sectionKey, enabledKey) => (e, checked) => {
  setState((previous) => ({
    ...previous,
    [sectionKey]: {
      ...previous[sectionKey],
      [enabledKey]: checked,
    },
  }));
};

export const createNumericFieldHandler = (setState, clampOptions, updater) => (e) => {
  const next = clampInt(e.target.value, clampOptions);

  setState((previous) => updater(previous, next));
};

export const createListCheckboxHandler = (setState, selector, updater) => (item) => (e) => {
  const isChecked = e.target.checked;

  setState((previous) => {
    const current = selector(previous);
    const next = isChecked ? Array.from(new Set([...current, item])) : current.filter((value) => value !== item);

    return updater(previous, next);
  });
};

export const disabledCardSx = {
    opacity: 0.6,
};

